// import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import { axiosInstance } from "../../../Utils/AxiosInstance";
// import { revertAll } from "../ResetStateAction";
// import GetQueryParams from "../../../Utils/GetQueryParams";

// const initialState = {
//   Activities: [],
//   Events: [],
//   isSuccess: false,
//   message: null,
//   status: "idle", //'idle' | 'loading' | 'succeeded' | 'failed'
//   error: null,
//   IsLogin: true,
// };

// export const fetchActivities = createAsyncThunk("/LeadActivities", async payload => {
//   const queryParams = GetQueryParams(payload);

//   const response = await axiosInstance.get(`/LeadActivities?${queryParams}`);
//   return response.data;
// });

// export const fetchActivityEvents = createAsyncThunk("/LeadActivities/allActivityEvents", async () => {
//   const response = await axiosInstance.get(`/LeadActivities/allActivityEvents`);

//   return response.data;
// });
// export const fetchFilterInput = createAsyncThunk("/LeadActivities/ByFilters", async data => {
//   const response = await axiosInstance.get(`/LeadActivities/ByFilters`, {
//     params: data,
//   });

//   return response.data;
// });

// const ActivitiesSlice = createSlice({
//   name: "Activities",
//   initialState,
//   reducers: {
//     ActivitiesAdded: {
//       reducer(state, action) {
//         state.Activities?.push(action.payload);
//       },
//     },
//   },
//   extraReducers(builder) {
//     builder
//       .addCase(revertAll, () => initialState)
//       .addCase(fetchActivities.pending, state => {
//         state.status = "loading";
//       })
//       .addCase(fetchActivities.fulfilled, (state, action) => {
//         state.status = "succeeded";
//         state.message = action.payload.Message;
//         state.isSuccess = action.payload.IsSuccess;
//         state.Activities = action.payload;
//       })
//       .addCase(fetchActivities.rejected, (state, action) => {
//         state.error = action.error.message;
//         state.status = "failed";
//         state.Activities = null;
//       })
//       .addCase(fetchFilterInput.pending, state => {
//         state.status = "loading";
//       })
//       .addCase(fetchFilterInput.fulfilled, (state, action) => {
//         state.status = "succeeded";
//         state.message = action.payload.Message;
//         state.isSuccess = action.payload.IsSuccess;
//         state.Activities = action.payload.Data;
//       })
//       .addCase(fetchFilterInput.rejected, (state, action) => {
//         state.error = action.error.message;
//         state.status = "failed";
//       })
//       .addCase(fetchActivityEvents.pending, state => {
//         state.status = "loading";
//       })
//       .addCase(fetchActivityEvents.fulfilled, (state, action) => {
//         state.status = "succeeded";
//         state.message = action.payload.Message;
//         state.isSuccess = action.payload.IsSuccess;
//         state.Events = action.payload.Data;
//       })
//       .addCase(fetchActivityEvents.rejected, (state, action) => {
//         state.error = action.error.message;
//         state.status = "failed";
//       });
//   },
// });

// export const getActivitiesDetails = state => state.Activities;

// export const { ActivitiesAdded } = ActivitiesSlice.actions;

// export default ActivitiesSlice.reducer;

import { createSlice, createAsyncThunk, createSelector } from "@reduxjs/toolkit";
import { axiosInstance } from "../../../Utils/AxiosInstance";
import { revertAll } from "../ResetStateAction";
import GetQueryParams from "../../../Utils/GetQueryParams";
import { TABLE_CACHE_EXPIRY_MS } from "../../../config/cacheConfig";

const selectActivitiesSlice = state => state.Activities;
const selectCache = state => state.Activities.tableCache;

const initialState = {
  Activities: [],
  Events: [],
  isSuccess: false,
  message: null,
  status: "idle", // 'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
  IsLogin: true,

  tableCache: {
    activities: {},
    cacheExpiry: TABLE_CACHE_EXPIRY_MS,
    activeCacheKey: null,
  },
};

const generateActivitiesCacheKey = (queryParams = {}) => {
  const normalizedParams = {
    PageNumber: queryParams?.PageNumber || 1,
    PageSize: queryParams?.PageSize || 50,
    leadId: queryParams?.leadId || "",
    activityTypeId: queryParams?.activityTypeId || "",
    userId: queryParams?.userId || "",
    startDate: queryParams?.startDate || "",
    endDate: queryParams?.endDate || "",
    status: queryParams?.status || "",
    search: queryParams?.search || "",
    sortBy: queryParams?.sortBy || "CreatedAt",
    sortOrder: queryParams?.sortOrder || "desc",
    pipelineStageId: queryParams?.pipelineStageId || "",
    personId: queryParams?.personId || "",
    activityType: queryParams?.activityType || "",
    projectId: queryParams?.projectId || "",
    userid: queryParams?.userid || "",
    activityName: queryParams?.activityName || "",
    leadTitle: queryParams?.leadTitle || "",
    activityState: queryParams?.activityState || "",
    subType: queryParams?.subType || "",
    type: queryParams?.type || "",
  };

  const sortedParams = Object.keys(normalizedParams)
    .sort()
    .reduce((acc, key) => {
      acc[key] = normalizedParams[key];
      return acc;
    }, {});

  const queryString = JSON.stringify(sortedParams);
  return `activities_${queryString}`;
};

const isCacheValid = (cachedEntry, cacheExpiry) => {
  if (!cachedEntry || !cachedEntry.timestamp) {
    return false;
  }
  const currentTime = Date.now();
  const cacheAge = currentTime - cachedEntry.timestamp;
  return cacheAge < cacheExpiry;
};

const hasCacheForQuery = (state, queryParams) => {
  const cacheKey = generateActivitiesCacheKey(queryParams);
  if (!cacheKey) return false;

  const cachedData = state.Activities.tableCache.activities[cacheKey];
  return cachedData && isCacheValid(cachedData, state.Activities.tableCache.cacheExpiry);
};

export const fetchActivities = createAsyncThunk("/LeadActivities", async (payload = {}, { getState, dispatch }) => {
  const state = getState();
  const activitiesSlice = state.Activities;

  const cacheKey = generateActivitiesCacheKey(payload);

  if (cacheKey && activitiesSlice.tableCache.activities[cacheKey]) {
    const cachedData = activitiesSlice.tableCache.activities[cacheKey];

    if (isCacheValid(cachedData, activitiesSlice.tableCache.cacheExpiry)) {
      dispatch(setActiveCacheKey(cacheKey));

      return {
        ...cachedData.data,
        fromCache: true,
        cacheKey: cacheKey,
      };
    }
  }

  const queryParams = GetQueryParams(payload);

  try {
    const response = await axiosInstance.get(`/LeadActivities?${queryParams}`);

    const result = {
      ...response.data,
      fromCache: false,
      cacheKey: cacheKey,
    };

    if (response.data?.Succeeded && cacheKey) {
      dispatch(
        updateTableCache({
          key: cacheKey,
          data: response.data,
        })
      );
    }

    return result;
  } catch (error) {
    console.error("❌ Error fetching activities:", error);
    console.error("📞 API endpoint called:", `/LeadActivities?${queryParams}`);
    throw error;
  }
});

export const fetchActivityEvents = createAsyncThunk("/LeadActivities/allActivityEvents", async () => {
  const response = await axiosInstance.get(`/LeadActivities/allActivityEvents`);
  return response.data;
});

export const fetchFilterInput = createAsyncThunk("/LeadActivities/ByFilters", async (data, { getState, dispatch }) => {
  const state = getState();
  const activitiesSlice = state.Activities;

  const cacheKey = generateActivitiesCacheKey(data);

  if (cacheKey && activitiesSlice.tableCache.activities[cacheKey]) {
    const cachedData = activitiesSlice.tableCache.activities[cacheKey];

    if (isCacheValid(cachedData, activitiesSlice.tableCache.cacheExpiry)) {
      dispatch(setActiveCacheKey(cacheKey));

      return {
        ...cachedData.data,
        fromCache: true,
        cacheKey: cacheKey,
      };
    }
  }

  try {
    const response = await axiosInstance.get(`/LeadActivities/ByFilters`, {
      params: data,
    });

    const result = {
      ...response.data,
      fromCache: false,
      cacheKey: cacheKey,
    };

    if (response.data?.Succeeded && cacheKey) {
      dispatch(
        updateTableCache({
          key: cacheKey,
          data: response.data,
        })
      );
    }

    return result;
  } catch (error) {
    console.error("❌ Error fetching filtered activities:", error);
    console.error("📞 API endpoint called:", `/LeadActivities/ByFilters`, data);
    throw error;
  }
});

const ActivitiesSlice = createSlice({
  name: "Activities",
  initialState,
  reducers: {
    ActivitiesAdded: {
      reducer(state, action) {
        state.Activities?.push(action.payload);
      },
    },

    updateTableCache: (state, action) => {
      const { key, data } = action.payload;

      if (!key || !data) {
        console.warn("⚠️ updateTableCache called with invalid key or data");
        return;
      }

      const newCacheEntry = {
        data: { ...data },
        timestamp: Date.now(),
        totalRecords: data.TotalRecords || 0,
      };

      state.tableCache.activities = {
        ...state.tableCache.activities,
        [key]: newCacheEntry,
      };

      state.tableCache.activeCacheKey = key;
    },

    invalidateActivitiesCache: (state, action) => {
      const { specificKey } = action.payload || {};

      if (specificKey) {
        delete state.tableCache.activities[specificKey];
      } else {
        state.tableCache.activities = {};
      }

      state.tableCache.activeCacheKey = null;
    },

    invalidateActivitiesByLeadId: (state, action) => {
      const { leadId } = action.payload;

      if (leadId) {
        Object.keys(state.tableCache.activities).forEach(key => {
          if (key.includes(`"leadId":"${leadId}"`) || key.includes(`"leadId":${leadId}`)) {
            delete state.tableCache.activities[key];
          }
        });
      }
    },

    clearAllCache: state => {
      state.tableCache.activities = {};
      state.tableCache.activeCacheKey = null;
    },

    setActiveCacheKey: (state, action) => {
      state.tableCache.activeCacheKey = action.payload;
    },

    setCacheExpiry: (state, action) => {
      state.tableCache.cacheExpiry = action.payload;
    },

    updateActivityInCache: (state, action) => {
      const { activityId, updatedData } = action.payload;
      const cacheKey = state.tableCache.activeCacheKey;

      if (!cacheKey) return;

      const cachedData = state.tableCache.activities[cacheKey];
      if (cachedData?.data?.data) {
        const updatedActivities = cachedData.data.data.map(activity =>
          activity.ActivtyId === activityId ? { ...activity, ...updatedData } : activity
        );
        cachedData.data.data = updatedActivities;
        cachedData.timestamp = Date.now();
      }
    },

    addActivityToCache: (state, action) => {
      const { activity } = action.payload;
      const cacheKey = state.tableCache.activeCacheKey;

      if (!cacheKey || !activity) return;

      const cachedData = state.tableCache.activities[cacheKey];
      if (cachedData?.data?.data) {
        cachedData.data.data.unshift(activity);
        cachedData.data.TotalRecords = (cachedData.data.TotalRecords || 0) + 1;
        cachedData.timestamp = Date.now();
      }
    },

    removeActivityFromCache: (state, action) => {
      const { activityId } = action.payload;
      const cacheKey = state.tableCache.activeCacheKey;

      if (!cacheKey) return;

      const cachedData = state.tableCache.activities[cacheKey];
      if (cachedData?.data?.data) {
        cachedData.data.data = cachedData.data.data.filter(activity => activity.ActivtyId !== activityId);
        cachedData.data.TotalRecords = Math.max(0, (cachedData.data.TotalRecords || 1) - 1);
        cachedData.timestamp = Date.now();
      }
    },
  },
  extraReducers(builder) {
    builder
      .addCase(revertAll, () => initialState)

      .addCase(fetchActivities.pending, state => {
        state.status = "loading";
      })
      .addCase(fetchActivities.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.message = action.payload.Message;
        state.isSuccess = action.payload.Succeeded;

        const { fromCache, cacheKey, ...apiData } = action.payload;
        state.Activities = apiData;

        if (cacheKey && !fromCache) {
          state.tableCache.activeCacheKey = cacheKey;
        }
      })
      .addCase(fetchActivities.rejected, (state, action) => {
        state.error = action.error.message;
        state.status = "failed";
        state.Activities = null;
      })

      .addCase(fetchFilterInput.pending, state => {
        state.status = "loading";
      })
      .addCase(fetchFilterInput.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.message = action.payload.Message;
        state.isSuccess = action.payload.Succeeded;

        const { fromCache, cacheKey, ...apiData } = action.payload;
        state.Activities = apiData;

        if (cacheKey && !fromCache) {
          state.tableCache.activeCacheKey = cacheKey;
        }
      })
      .addCase(fetchFilterInput.rejected, (state, action) => {
        state.error = action.error.message;
        state.status = "failed";
      })

      .addCase(fetchActivityEvents.pending, state => {
        state.status = "loading";
      })
      .addCase(fetchActivityEvents.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.message = action.payload.Message;
        state.isSuccess = action.payload.Succeeded;
        state.Events = action.payload.Data;
      })
      .addCase(fetchActivityEvents.rejected, (state, action) => {
        state.error = action.error.message;
        state.status = "failed";
      });
  },
});

// ===== SELECTORS =====
// export const selectActivitiesData = state => {
//   const activeKey = state.Activities.tableCache.activeCacheKey;

//   let activitiesData = [];
//   let totalRecords = 0;
//   let pageNumber = 1;
//   let pageSize = 50;

//   if (activeKey && state.Activities.tableCache.activities[activeKey]) {
//     const cached = state.Activities.tableCache.activities[activeKey];
//     activitiesData = cached.data?.data || [];
//     totalRecords = cached.totalRecords || 0;
//     pageNumber = cached.data?.PageNumber || 1;
//     pageSize = cached.data?.PageSize || 50;
//   } else {
//     activitiesData = state.Activities.Activities?.data || [];
//     totalRecords = state.Activities.Activities?.TotalRecords || 0;
//     pageNumber = state.Activities.Activities?.PageNumber || 1;
//     pageSize = state.Activities.Activities?.PageSize || 50;
//   }

//   return {
//     data: activitiesData,
//     totalRecords,
//     pageNumber,
//     pageSize,
//     totalPages: state.Activities.Activities?.TotalPages || 0,
//   };
// };
export const selectActivitiesData = createSelector(
  [selectActivitiesSlice, selectCache],
  (activitiesState, tableCache) => {
    const activeKey = tableCache.activeCacheKey;

    let activitiesData = [];
    let totalRecords = 0;
    let pageNumber = 1;
    let pageSize = 50;
    let totalPages = 0;

    if (activeKey && tableCache.activities[activeKey]) {
      const cached = tableCache.activities[activeKey];

      activitiesData = cached.data?.data || [];
      totalRecords = cached.totalRecords || 0;
      pageNumber = cached.data?.PageNumber || 1;
      pageSize = cached.data?.PageSize || 50;
      totalPages = cached.data?.TotalPages || 0;
    } else {
      const apiData = activitiesState.Activities;

      activitiesData = apiData?.data || [];
      totalRecords = apiData?.TotalRecords || 0;
      pageNumber = apiData?.PageNumber || 1;
      pageSize = apiData?.PageSize || 50;
      totalPages = apiData?.TotalPages || 0;
    }

    return {
      data: activitiesData,
      totalRecords,
      pageNumber,
      pageSize,
      totalPages,
    };
  }
);


export const selectIsActivitiesFromCache = state => state.Activities.Activities?.fromCache || false;

export const selectActiveCacheKey = state => state.Activities.tableCache.activeCacheKey;

export const selectCacheStats = state => {
  const activitiesCache = state.Activities.tableCache.activities;
  const keys = Object.keys(activitiesCache);

  return {
    totalCachedQueries: keys.length,
    cacheExpiry: state.Activities.tableCache.cacheExpiry,
    activeKey: state.Activities.tableCache.activeCacheKey,
  };
};

export const selectHasCacheForQuery = (state, queryParams) => {
  const cacheKey = generateActivitiesCacheKey(queryParams);
  if (!cacheKey) return false;

  const cachedData = state.Activities.tableCache.activities[cacheKey];
  return cachedData && isCacheValid(cachedData, state.Activities.tableCache.cacheExpiry);
};

export const getActivitiesDetails = state => state.Activities;

export const {
  ActivitiesAdded,
  updateTableCache,
  invalidateActivitiesCache,
  invalidateActivitiesByLeadId,
  clearAllCache,
  setActiveCacheKey,
  setCacheExpiry,
  updateActivityInCache,
  addActivityToCache,
  removeActivityFromCache,
} = ActivitiesSlice.actions;

export { generateActivitiesCacheKey, isCacheValid, hasCacheForQuery };

export default ActivitiesSlice.reducer;
